import styled from 'styled-components'

import Box from '@components/atoms/Box'

export const Root = styled(Box)``
